// Get Care 2.0 (Masonry V2) root nodes.
// Web renders two columns explicitly (see CIG-10988) instead of relying on the
// care-discovery SDK landing, which does not render the right column yet.
export const MasonryGetCareLeftRootNodeId = 'getCarePageWebLeft$root';
export const MasonryGetCareRightRootNodeId = 'getCarePageWebRight$root';
export const MasonryGetCareMobileRootNodeId = 'getCarePage$root';
